import { Navigate, Outlet } from 'react-router-dom';

import { isAuthenticated } from '@/auth/authUtils';

type ProtectedRouteProps = {
  redirectTo?: string;
  children?: React.ReactNode;
};

export function ProtectedRoute({ redirectTo = '/login', children }: ProtectedRouteProps) {
  if (!isAuthenticated()) {
    return <Navigate to={redirectTo} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}
